<sc-modal>
  <div class="flex justify-between mb-6">
    <h3
      class="text-mobileH3 tablet:text-tabletH3 desktop:text-desktopH3 font-headline"
    >
      {{ 'components.pendingPaymentModal.label' | scTranslate | async }}
    </h3>
    <sc-button 
      variant="icon" 
      [padding]="false" 
      (click)="close(false)"
    >
      <sc-svg name="cross" size="w-8 h-8"></sc-svg>
    </sc-button>
  </div>
  <div class="font-semibold mb-1">
    {{ 'components.pendingPaymentModal.title' | scTranslate | async }}
  </div>
  <p class="text-secondaryText">
    {{ 'components.pendingPaymentModal.subTitle1' | scTranslate | async }}
  </p>
  <p class="text-secondaryText mt-2">
    {{ 'components.pendingPaymentModal.subTitle1' | scTranslate | async }}
  </p>
  <sc-modal-footer>
    <sc-button variant="primary" (click)="close(true)">
      <span>
        {{
          'components.pendingPaymentModal.goToInvoices' | scTranslate | async
        }}
      </span>
    </sc-button>
  </sc-modal-footer>
</sc-modal>
